"use strict";

require("core-js/modules/es6.date.to-json");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std */
//================================================================

/**
 * Base Exception.
 *
 * @author Jeongho Nam <http://samchon.org>
 */

var Exception =
/** @class */
function (_super) {
  __extends(Exception, _super);

  function Exception(message) {
    var _newTarget = this.constructor;

    if (message === void 0) {
      message = "";
    }

    var _this = _super.call(this, message) || this; // INHERITANCE POLYFILL


    var proto = _newTarget.prototype;
    if (Object.setPrototypeOf) Object.setPrototypeOf(_this, proto);else _this.__proto__ = proto;
    return _this;
  }

  Object.defineProperty(Exception.prototype, "name", {
    /* ---------------------------------------------------------
        ACCESSORS
    --------------------------------------------------------- */

    /**
     * The error name.
     */
    get: function get() {
      return this.constructor.name;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Get error message.
   *
   * @return The error message.
   */

  Exception.prototype.what = function () {
    return this.message;
  };
  /**
   * Native function for `JSON.stringify()`.
   *
   * The {@link Exception.toJSON} function returns only three properties; ({@link name}, {@link message} and {@link stack}). If you want to define a new sub-class extending the {@link Exception} and let the class to export additional props (or remove some props), override this {@link Exception.toJSON} method.
   *
   * @return An object for `JSON.stringify()`.
   */


  Exception.prototype.toJSON = function () {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack
    };
  };

  return Exception;
}(Error);

exports.Exception = Exception;
exports.exception = Exception;